import { DataType } from '@ndvr/customer-api';

export const encryptData = (encryptionContextGUID: string, dataType: DataType, data?: string) =>
    data
        ? {
              encryptionContextGUID: encryptionContextGUID,
              dataType: dataType,
              plainText: data,
          }
        : undefined;
